import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '../../components/Error';
import Footer from '../../components/Footer';

const QRCodeConfig = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [teamCode, setTeamCode] = useState('');
  const [showInput, setShowInput] = useState(false);
  const { t } = useTranslation();
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [codeError, setCodeError] = useState(false);
  const [teamNotFoundError, setTeamNotFoundError] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/qrcode/${id}`)
      .then(response => response.json())
      .then(data => {
        if (data.trouve) {
          navigate(`/team/${data.id}`);
        } else if (!data.trouve && data.lien === "") {
          setShowInput(true);
        } else if (data.lien === "ERROR") {
          setError("QR Code invalide");
        }
        setLoading(false);
      })
      .catch(error => {
        setError(error.message);
        setLoading(false);
      });
  }, [id, navigate]); 
  

  const handleSubmit = () => {
    if (teamCode.length !== 6) {
      setCodeError(true);
      return;
    }
    setCodeError(false);
    setShowConfirmPopup(true);
  };

  const confirmJoinTeam = () => {
    fetch(`${process.env.REACT_APP_API_URL}/qrcode/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ code: teamCode })
    })
      .then(response => response.json())
      .then(data => {
        if (data.trouve) {
          navigate(`/team/${data.id}`);
        } else {
          setTeamNotFoundError(true);
        }
        setShowConfirmPopup(false);
      })
      .catch(error => {
        setError("Erreur de connexion au serveur");
        setShowConfirmPopup(false);
      });
  };

  if (loading) {
    return (
      <div>
        <div className="text-animated flex justify-center items-center w-full pt-32">
          <div className="text-center">
            <div className="font-bold text-5xl md:text-6xl lg:text-8xl mt-12 w-full max-w-sm sm:max-w-xs md:max-w-md lg:max-w-lg mx-auto">
              {t('teamTitle')}
            </div>
            <div className="font-bold text-3xl mt-4 w-full max-w-sm sm:max-w-xs md:max-w-md lg:max-w-lg mx-auto">
              {t('contactless_tips')}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return <ErrorPage message={error} />;
  }

  return (
    <div className="relative no-scroll min-h-screen bg-modern text-black flex flex-col justify-between overflow-hidden">
      <div className="container mx-auto w-full flex flex-col items-center h-screen">
        <div className="bg-white w-full max-w-full rounded-b-3xl shadow-lg px-6 py-16 text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-black">
            {t('teamTitle')}
          </h1>
        </div>

        {showInput ? (
          <div className="w-full max-w-lg p-6 md:p-8 bg-white rounded-lg shadow-lg text-center">
            <p className="text-2xl font-semibold mb-6">{t('enter_team_code')}</p>
            <input
              type="text"
              className="w-full px-6 py-3 border rounded-lg text-center tracking-widest text-3xl"
              value={teamCode}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                setTeamCode(value);
                setCodeError(false);
                setTeamNotFoundError(false);
              }}
              placeholder="XXXXXX"
              maxLength="6"
              inputMode="numeric"
              pattern="\d{6}"
            />
            {codeError && <p className="text-red-500 text-lg mt-2">{t('code_must_be_six_digits')}</p>}
            {teamNotFoundError && <p className="text-red-600 text-lg mt-2">{t('team_not_found')}</p>}
            <button
              onClick={handleSubmit}
              className="mt-6 w-full bg-black text-white py-3 rounded-lg text-xl"
            >
              {t('submit')}
            </button>
          </div>
        ) : null}
      </div>
      {showConfirmPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-8 md:p-12 rounded-lg shadow-lg text-center w-11/12 max-w-lg">
            <p className="text-2xl font-semibold mb-6">{t('confirmJoinTeam')}</p>
            <p className="text-4xl font-bold text-gray-800 mb-6">{teamCode}</p>
            <div className="flex justify-center space-x-6">
              <button onClick={confirmJoinTeam} className="bg-black text-white px-6 py-3 rounded-lg text-xl">
                {t('yes')}
              </button>
              <button onClick={() => setShowConfirmPopup(false)} className="bg-gray-300 text-black px-6 py-3 rounded-lg text-xl">
                {t('no')}
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default QRCodeConfig;